@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.list {
  display: flex;
  flex-direction: column;
  padding: 8px;
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  width: 100%;
  max-width: 360px;
  height: auto;
  max-height: 248px;
  overflow: hidden;
  border-radius: 6px;
  border: 1px solid v.$gray-border-color;
  background: v.$navy-color;
  box-shadow: v.$shadow-dropdown;
  z-index: 4;
}

.listChineseBrothers {
  background: v.$chinese-brothers-input-bg;
  border-color: v.$chinese-brothers-input-border;
}

.search {
  flex-shrink: 0;
  margin-bottom: 4px;
}

.searchInput {
  width: 100%;
  height: 40px;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid v.$gray-border-color;
  background: v.$navy-dark-color;
  color: v.$white-color;
  @include t.text(14px, 22px, "normal");
  transition: border-color 0.2s ease;

  &::placeholder {
    color: v.$gray-dark-color;
  }

  &:hover {
    border-color: v.$green-dark-color;
  }

  &:focus,
  &:focus-visible {
    outline: none;
    border-color: v.$green-color;
  }
}

.listChineseBrothers .searchInput {
  background: v.$chinese-brothers-input-bg;
  border-color: v.$chinese-brothers-input-border;
  color: v.$white-color;

  &::placeholder {
    color: rgb(255 255 255 / 40%);
  }

  &:hover {
    border-color: v.$chinese-brothers-input-border-hover;
  }

  &:focus,
  &:focus-visible {
    border-color: v.$chinese-brothers-input-border-active;
  }
}

.items {
  margin: 0;
  padding: 0;
  list-style: none;
  overflow-y: auto;
  min-height: 0;
}

.item {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
  padding: 8px;
  border-radius: 6px;
  color: v.$white-color;
  @include t.text(14px, 22px, "normal");

  &:hover {
    background-color: v.$gray-border-color;
  }
}

.listChineseBrothers .item:hover {
  background-color: v.$chinese-brothers-input-border;
}

.itemFlag {
  width: 18px;
  height: 12px;
}

.itemName {
  color: v.$white-color;
  @include t.text(14px, 22px, "normal");
}

.empty {
  padding: 8px;
  color: v.$gray-dark-color;
  @include t.text(14px, 22px, "normal");
}

.listChineseBrothers .empty {
  color: rgb(255 255 255 / 40%);
}
